import { Avatar as AvatarPrimitive } from 'radix-ui';
import type * as React from 'react';
import { cn } from '@/lib/utils';

// shadcn/ui (AD #39): shadcn's Avatar on Radix, adapted to the CRM's rules.
//   - The CRM shows initials only (it stores no photos), so `AvatarImage` is left out until a screen needs one;
//     `AvatarFallback` carries the initials.
//   - The size is the compact control height (`layout/control-h-compact`), as the §5 Avatar's, so an avatar sits
//     on the same rhythm as the controls beside it; the circle is the accent gold with its paired text colour.
//   - The person's name is the caller's to give: `PersonAvatar` (`src/ui/PersonAvatar.tsx`) names it with the
//     full name (`role="img"`) and hides the initials, so a screen reader reads the name, not two letters.
function Avatar({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Root>) {
    return (
        <AvatarPrimitive.Root
            data-slot="avatar"
            className={cn(
                'relative flex size-(--et-layout-control-h-compact) shrink-0 overflow-hidden rounded-full',
                className,
            )}
            {...props}
        />
    );
}

function AvatarFallback({ className, ...props }: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
    return (
        <AvatarPrimitive.Fallback
            data-slot="avatar-fallback"
            className={cn('flex size-full items-center justify-center rounded-full select-none', className)}
            {...props}
        />
    );
}

export { Avatar, AvatarFallback };
